import history from '../utils/history';

export default {
  // url without any query string
  getBareUrl: function (url?: string) {
    var questionIndex;
    url = url || window.location.href;
    questionIndex = url.indexOf("?");
    return url.substring(0, questionIndex > -1 ? questionIndex : url.length);
  },
  // url without any hash
  getUnhashedUrl: function (url?: string) {
    var hashIndex;
    url = url || window.location.href;
    hashIndex = url.indexOf("#");
    return url.substring(0, hashIndex > -1 ? hashIndex : url.length);
  },
  getProtocol: function (url?: string) {
    var r = "",
      i;
    url = this.getBareUrl(url || window.location.href);
    i = url.indexOf("://");
    if (i > -1) {
      r = url.substring(0, i);
    }
    return r;
  },
  getHostname: function (url?: string) {
    var protocol, start;
    url = this.getBareUrl(url || window.location.href);
    protocol = this.getProtocol(url);
    start = protocol ? protocol.length + 3 : 0;
    return url.substring(start, url.indexOf("/", start));
  },
  // query string only (no question mark)
  getQueryString: function (url?: string) {
    var questionIndex,
      r = window.location.search.substring(1, window.location.search.length);
    if (url) {
      url = this.getUnhashedUrl(url);
      questionIndex = url.indexOf("?");
      r = questionIndex > -1 ? url.substring(questionIndex + 1) : "";
    }
    return r;
  },
  updateQueryStringParam: function (key: string, value: string) {
    var baseUrl = [
        location.protocol,
        "//",
        location.host,
        location.pathname,
      ].join(""),
      queryString = document.location.search,
      newParam = key + "=" + value,
      params = "?" + newParam;

    if (queryString) {
      var keyRegex = new RegExp("([?&])" + key + "[^&]*");

      if (queryString.match(keyRegex) !== null) {
        params = queryString.replace(keyRegex, "$1" + newParam);
      } else {
        params = queryString + "&" + newParam;
      }
    }

    history.pushState({}, "", baseUrl + params);
  },
  getPathname: function (url?: string) {
    var hostname, questionIndex;
    url = url || window.location.href;
    hostname = this.getHostname(url);
    questionIndex = url.indexOf("?");
    return url.substring(
      url.indexOf(hostname) + hostname.length,
      questionIndex > -1 ? questionIndex : url.length
    );
  },
  // serialize an object literal into a url encoded string
  serialize: function (params: { [key: string]: string }) {
    var r = [],
      tempArray;
    for (var prop in params) {
      if (params[prop] !== null) {
        tempArray = [prop];
        tempArray.push("=");
        tempArray.push(encodeURIComponent(params[prop]));
        r.push(tempArray.join(""));
      }
    }
    return r.join("&");
  },
  htmlEscape: function (str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  },
  // returns an object literal of the url params on a url
  getUrlParams: function (url?: string) {
    var r: { [key: string]: string } | null = null,
      qs,
      paramPairs,
      keyValuePair,
      i = 0;

    qs = this.getQueryString(url);

    if (qs) {
      paramPairs = qs.split("&");
      for (i; i < paramPairs.length; i++) {
        if (!r) {
          r = {};
        }
        keyValuePair = paramPairs[i].split("=");
        r[keyValuePair[0]] =
          keyValuePair.length > 1
            ? this.htmlEscape(decodeURIComponent(keyValuePair[1]))
            : null;
      }
    }

    return r;
  },
  // returns a url with additional params added (params is an object literal)
  addUrlParams: function (params: {}, url?: string) {
    var r = [],
      qs;

    url = url || window.location.href;
    r.push(this.getBareUrl(url));
    params = { ...this.getUrlParams(url), ...params };
    qs = this.serialize(params);
    if (qs) {
      r.push("?");
      r.push(qs);
    }

    return r.join("");
  },
  // returns a url with params removed (params is an array of url param keys)
  removeUrlParams: function (params: {}, url?: string) {
    var r = [],
      qs;

    url = url || window.location.href;
    r.push(this.getBareUrl(url));
    var currentParams = this.getUrlParams(url);
    for (var i = params.length - 1; i >= 0; i--) {
      if (typeof currentParams[params[i]] !== "undefined") {
        delete currentParams[params[i]];
      }
    }

    qs = this.serialize(currentParams);
    if (qs) {
      r.push("?");
      r.push(qs);
    }

    return r.join("");
  },
  // returns a url without http(s)://(www.) and without trailing slash, optionally with url vars
  getSimpleUrl: function (url: string | null, matchUrlVars?: boolean) {
    url = url || window.location.href;

    var simpleMatch = /^((https?|):\/\/)?(www\.)?/;
    var trailingSlashMatch = /\/$/;

    var bareUrl = this.getBareUrl(url);
    var hashUrlArray = bareUrl.split("#");
    var hashUrl = "";

    bareUrl = hashUrlArray[0];
    if (hashUrlArray.length > 1) {
      hashUrl = "#" + hashUrlArray[1];
    }

    var result = bareUrl
      .replace(simpleMatch, "")
      .replace(trailingSlashMatch, "");

    if (matchUrlVars) {
      var queryString = this.getQueryString(url);

      if (queryString) {
        result += "?" + queryString;
      }
      result += hashUrl;
    }

    return result;
  },
}
